export const termsAr = {
  title: 'شروط وأحكام العملاء',
  intro: 'هذه شروط عملاء تيكيتاتي. تُشغّل تيكيتاتي شركة United Systema QFZ LLC، الشركة، من منطقة قطر الحرة. شراء تذكرة أو إنشاء حساب أو استخدام تيكيتاتي يعني قبولك هذه الشروط.',
  sections: [
    {
      id: 'who',
      title: '1. من نحن',
      paragraphs: [
        'تيكيتاتي هي خدمة التذاكر. United Systema QFZ LLC هي الشركة التي تشغّلها، من منطقة قطر الحرة. موقع الشركة هو www.united-systema.com. في هذه الشروط، «نحن» تعني تيكيتاتي، و«أنت» تعني الشخص الذي يتصفح الفعاليات أو يشتري التذاكر.',
      ],
    },
    {
      id: 'definitions',
      title: '2. التعريفات',
      paragraphs: [
        'الفعالية تعني عرضًا أو مباراة أو مؤتمرًا أو أي تجمع آخر مدرجًا على تيكيتاتي.',
        'المنظم هو الشخص أو الجهة المسؤولة عن إقامة الفعالية. يضع المنظم قواعد الفعالية وشروط المكان، ويقرر التغيير أو الإلغاء.',
        'التذكرة هي حق دخول مدفوع أو مجاني، يصدر كرمز QR أو باركود أو مرجع أو تصريح آخر عبر تيكيتاتي.',
        'الموقع يعني صفحات تيكيتاتي، بما فيها الصفحات المفتوحة على الهاتف أو الجهاز اللوحي أو الحاسوب.',
      ],
    },
    {
      id: 'account',
      title: '3. حسابك',
      paragraphs: [
        'يجب أن تقدّم اسمًا حقيقيًا وبريدًا يعمل، وإذا أضفت رقم جوال فيكون رقمًا تتحكم به. أنت مسؤول عن سرية كلمة المرور وعن الطلبات التي تتم من حسابك.',
        'يجوز لنا رفض حساب أو إيقافه أو إغلاقه إذا استُخدم للاحتيال أو لإعادة بيع تخالف هذه الشروط أو لإساءة استخدام الموقع.',
      ],
    },
    {
      id: 'purchase',
      title: '4. شراء التذكرة',
      paragraphs: [
        'التذكرة معروضة من المنظم. توفّر تيكيتاتي الإدراج وإتمام الدفع وتسليم التذكرة. عندما تدفع، فأنت تشتري الدخول إلى فعالية ذلك المنظم وفق ما يظهر في صفحة الفعالية، بما في ذلك التاريخ والمكان والفئة وأي شرط للعمر أو الدخول.',
        'راجع اسم الفعالية وتاريخها ومكانها والكمية قبل الدفع. يُؤكد الطلب عندما ينجح الدفع وتُصدر التذكرة إلى حسابك أو بريدك.',
      ],
    },
    {
      id: 'price',
      title: '5. السعر والدفع',
      paragraphs: [
        'السعر الظاهر عند الدفع هو المبلغ الذي تدفعه، شامل أي رسم يُعرض قبل التأكيد. الضرائب، إن وُجدت، تدخل في المبلغ المعروض أو تُذكر بجانبه. قد يُعرض السعر بعملة أخرى للتيسير، ويبقى الخصم بعملة الفعالية.',
        'يُحصَّل المبلغ عبر وسيلة الدفع المعروضة عند الإتمام. إذا رُفض الدفع أو عُكس أو تم ببطاقة لا يحق لك استخدامها، يجوز لنا إلغاء التذاكر دون بديل.',
      ],
    },
    {
      id: 'delivery',
      title: '6. تسليم التذكرة',
      paragraphs: [
        'تصل التذاكر عادة إلى حسابك على تيكيتاتي وبالبريد بعد الدفع. احتفظ بالتذكرة كما تحتفظ بتصريح مطبوع. إذا مسحها شخص آخر أولًا، يجوز للمكان رفض دخول ثانٍ، ولا نستبدل تذكرة شُوركت أو نُسخت أو فُقدت.',
      ],
    },
    {
      id: 'entry',
      title: '7. الدخول إلى الفعالية',
      paragraphs: [
        'المنظم والمكان يتحكمان في الدخول. قد يُطلب إبراز التذكرة وهوية مطابقة والبطاقة المستخدمة في الدفع. احضر مبكرًا بما يكفي لإجراءات الدخول. التأخر وقواعد اللباس والحقائب وحدود العمر يضعها المنظم، لا تيكيتاتي.',
        'التذكرة صالحة للفعالية والتاريخ والفئة المذكورة. ليست وعدًا بموقع رؤية معيّن إلا إذا نص الإعلان على ذلك.',
      ],
    },
    {
      id: 'changes',
      title: '8. التغيير والتأجيل والإلغاء',
      paragraphs: [
        'يجوز للمنظم تغيير الوقت أو المكان أو المشاركين أو تفاصيل أخرى، أو تأجيل الفعالية أو إلغاءها. نمرّر التحديث الذي يصلنا عبر البريد أو الهاتف المسجّل في الطلب متى أمكن.',
        'إذا أُلغيت الفعالية ولم يُعد جدولتها، تُطبَّق قاعدة الاسترداد المذكورة في صفحة الفعالية. وإذا خلت الصفحة من ذلك، يُرد سعر التذكرة إلى وسيلة الدفع الأصلية. تغيير فقرة مساندة، أو المقعد ضمن الفئة نفسها، أو تغيير معقول في وقت البدء، لا يُعد إلغاءً بحد ذاته.',
      ],
    },
    {
      id: 'refunds',
      title: '9. الاسترداد',
      paragraphs: [
        'التذاكر بوجه عام غير قابلة للاسترداد أو الاستبدال بعد إصدارها، إلا إذا أُلغيت الفعالية، أو أوجب قانون دولة قطر الرد، أو نصت صفحة الفعالية على مهلة تراجع أو قاعدة استرداد.',
        'لا نرد ثمن تذكرة لأنك غيّرت خططك أو اخترت تاريخًا خاطئًا أو لم تعد ترغب في الحضور. تُرد رسوم الخدمة فقط عندما تُلغى الفعالية وكانت الرسوم قد حُصّلت من تيكيتاتي عن تذكرة تُرد بالكامل.',
      ],
    },
    {
      id: 'resale',
      title: '10. إعادة البيع',
      paragraphs: [
        'لا تعد بيع تذكرة تيكيتاتي على موقع آخر أو بأعلى من السعر الذي دفعته، إلا إذا سمح المنظم بذلك في صفحة الفعالية. يجوز لنا إلغاء تذكرة نعتقد أنها أُعيد بيعها خلافًا لهذه الشروط. ويمكن رفض الدخول، ولا يستحق رد في هذه الحالة.',
        'يجوز لك إعطاء التذكرة لضيف يدخل معك إذا سمح المنظم بذلك. تبقى مسؤولًا عن استخدام ذلك الضيف للتذكرة.',
      ],
    },
    {
      id: 'use',
      title: '11. استخدام الموقع',
      paragraphs: [
        'لا تُسئ استخدام تيكيتاتي. يشمل ذلك محاولة تعطيل الدفع، أو سحب بيانات الموقع بطريقة تضعفه، أو إنشاء حسابات وهمية، أو التدخل في طلب عميل آخر.',
        'تُعرض أوصاف الفعاليات وصورها لتقرر إن كنت ستحضر. المنظم مسؤول عن دقة المحتوى الذي يقدّمه.',
      ],
    },
    {
      id: 'liability',
      title: '12. المسؤولية',
      paragraphs: [
        'تيكيتاتي خدمة تذاكر. المنظم مسؤول عن الفعالية نفسها وعن السلامة في المكان وعن التجربة التي تحصل عليها هناك. تيكيتاتي ليست الجهة المنظمة للفعالية إلا إذا نص الإعلان على أن United Systema QFZ LLC هي المنظم.',
        'لا شيء في هذه الشروط يحدّ من مسؤولية لا يجوز الحد منها بموجب قوانين دولة قطر. وفيما عدا ذلك، تقتصر مسؤوليتنا عن مطالبة تتعلق بتذكرة على المبلغ الذي دفعته مقابل تلك التذكرة عبر تيكيتاتي.',
      ],
    },
    {
      id: 'ip',
      title: '13. الملكية الفكرية',
      paragraphs: [
        'اسم تيكيتاتي وتصميمها وبرمجياتها مملوكة لـ United Systema QFZ LLC، الشركة التي تشغّل تيكيتاتي، أو للمرخّصين لها. أسماء الفعاليات والأعمال الفنية وأسماء الفنانين مملوكة لأصحابها. لا يجوز نسخ الموقع أو التذاكر إلا بالقدر اللازم لحضور الفعالية.',
      ],
    },
    {
      id: 'law',
      title: '14. القانون والتواصل',
      paragraphs: [
        'تخضع هذه الشروط لقوانين دولة قطر. تختص محاكم قطر بالنزاعات، من دون مساس بأي حق إلزامي لك كمستهلك.',
        'للاستفسار عن شروط تيكيتاتي: United Systema QFZ LLC، منطقة قطر الحرة. الهاتف وواتساب +974 77363006. الموقع www.united-systema.com.',
        'طريقة تعاملنا مع البيانات الشخصية موضحة في سياسة الخصوصية.',
      ],
    },
  ],
};

export const privacyAr = {
  title: 'سياسة الخصوصية',
  intro: 'هذه سياسة خصوصية تيكيتاتي. تُشغّل تيكيتاتي شركة United Systema QFZ LLC، الشركة، من منطقة قطر الحرة. توضّح السياسة ما تجمعه تيكيتاتي عندما تتصفح الفعاليات أو تنشئ حسابًا أو تشتري تذكرة.',
  sections: [
    {
      id: 'who',
      title: '1. الجهة المسؤولة',
      paragraphs: [
        'تيكيتاتي هي الخدمة. United Systema QFZ LLC، الشركة في منطقة قطر الحرة، هي المسؤولة عن البيانات الشخصية التي تحتفظ بها تيكيتاتي. موقع الشركة www.united-systema.com. الهاتف وواتساب +974 77363006.',
      ],
    },
    {
      id: 'data',
      title: '2. البيانات التي نجمعها',
      paragraphs: [
        'بيانات الحساب التي ترسلها: الاسم والبريد وكلمة المرور ورقم الجوال إذا أضفته.',
        'بيانات الطلب: الفعاليات وفئات التذاكر والكميات والمبلغ المدفوع ومرجع دفع من مزوّد الدفع. لا نخزّن أرقام البطاقات كاملة على خوادم تيكيتاتي.',
        'بيانات تقنية: نوع المتصفح والجهاز والصفحات التي تُعرض، وذلك لإبقاء الموقع يعمل ومعرفة الصفحات التي تتعطل.',
      ],
    },
    {
      id: 'use',
      title: '3. كيف نستخدمها',
      paragraphs: [
        'نستخدم هذه البيانات لإنشاء حسابك وأخذ الدفع وإصدار التذاكر وإرسالها إليك، ولإخبارك إذا تغيّرت الفعالية أو أُلغيت.',
        'نستخدمها أيضًا لمنع الاحتيال والرد على طلب دعم والوفاء بواجبات حفظ السجلات التي تنطبق على United Systema QFZ LLC بصفتها الشركة المشغّلة لتيكيتاتي.',
      ],
    },
    {
      id: 'sharing',
      title: '4. مع من نشاركها',
      paragraphs: [
        'يتلقى منظم الفعالية التي تشتريها المعلومات اللازمة لدخولك، مثل اسمك ومرجع التذكرة والفئة التي اشتريتها.',
        'يتلقى مزوّدو الدفع التفاصيل اللازمة لأخذ المبلغ أو رده. يعالج مزوّدو الاستضافة والبريد البيانات فقط لتشغيل تيكيتاتي.',
        'المنظمون الذين يريدون توظيف مواهب أو تخزين صور يستخدمون منتجات مستقلة. تُحال طلبات المواهب إلى Talencia. ويُحال تخزين الصور ومشاركتها بأمان مع التعرف على الوجه إلى CamupAI. لتلك الخدمات شروطها الخاصة. شراء تذكرة من تيكيتاتي لا يُسجّلك بذاته في التعرف على الوجه.',
      ],
    },
    {
      id: 'cookies',
      title: '5. ملفات تعريف الارتباط',
      paragraphs: [
        'تستخدم تيكيتاتي ملفات تعريف الارتباط وتخزينًا مشابهًا لإبقائك مسجّلًا، ولتذكّر خطوة الانتظار أو الدفع، ولحماية النموذج من الإساءة. يمكنك حظرها من المتصفح، وقد تتوقف عندها أجزاء من الدفع عن العمل.',
      ],
    },
    {
      id: 'retention',
      title: '6. مدة الاحتفاظ',
      paragraphs: [
        'نحتفظ بسجلات الحساب والطلب ما دام حسابك مفتوحًا وللمدة اللازمة لمعالجة الاسترداد والنزاعات والمحاسبة. تُحفظ السجلات التقنية لمدة أقصر.',
      ],
    },
    {
      id: 'rights',
      title: '7. خياراتك',
      paragraphs: [
        'يمكنك أن تسألنا عن بيانات الحساب التي نحتفظ بها، أو أن تطلب تصحيحها، أو أن تطلب إغلاق حسابك. قد نُبقي سجل طلب إذا كنا لا نزال نحتاجه لنزاع دفع أو لواجب قانوني.',
        'راسل تيكيتاتي لدى United Systema QFZ LLC، منطقة قطر الحرة، أو اتصل على +974 77363006. راجع أيضًا شروط العملاء.',
      ],
    },
  ],
};
